import styled, { css } from 'styled-components';
import { Typography } from '@material-ui/core';
import { colors, fonts } from 'theme/Variables';

const HeaderTypography = styled(Typography)`
    color: ${({ customcolor }) => customcolor || colors.primary['900']};
    width: ${({ width }) => (width ? `${width}%` : '100%')};
    font-size: 2rem !important;
    font-family: ${({ customfont }) => customfont || fonts.primary} !important;

    ${({ pathname }) =>
        pathname === '/' &&
        css`
            text-align: center;
            font-size: 4rem !important;
        `}
`;

export default HeaderTypography;
